<template>
  <div class="cart-header flex jc-between ai-center m-b-3 p-t-2">
    <div>
      <button class="btn btn-sm btn-icon" @click="close">
        <span class="ti-arrow-left"></span>
        <span>Назад</span>
      </button>
    </div>
    <div v-if="user" class="card-item-user ta-right">
      <div class="fw-6 text-x5">{{ user.name }}</div>
      <div class="font-italic">
        <div>
          <span v-if="user.role.id == 9">Супервайзер</span>
          <span v-else>Торговый представитель</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "header",
  props: ["card", "user"],
  methods: {
    close() {
      let query = Object.assign({}, this.$route.query);
      if (query[this.card]) {
        delete query[this.card];
      } else {
        return false;
      }
      this.$router.replace({ query });
    },
  },
  components: {},
};
</script>
<style>
</style>
